/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { axiosInstance } from "../utils/axiosInstance";
import toast from "react-hot-toast";
import Loader from "../Loader";

export const TabReview = ({ productId }) => {
  const id = productId?.id;

  const [review, setReview] = useState(null);
  const [loader, setLoader] = useState(null);
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    review: Yup.string().required("Review cannot be empty"),
    rating: Yup.number()
      .min(1, "Please select a rating")
      .required("Rating is required"),
  });

  const getReview = async () => {
    setLoader(true);
    try {
      await axiosInstance
        .get(`user/review`, {
          params: { product_id: id },
        })
        .then((response) => {
          if (response?.data?.status === true) {
            setLoader(false);
            setReview(response?.data?.reviews);
          }
        });
    } catch (error) {
      setLoader(false);
    }
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const formData = new FormData();
      formData.append("product_id", id);
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("rating", values.rating);
      formData.append("review", values.review);
      const response = await axiosInstance.post("/user/review", formData);
      if (response?.data?.status) {
        getReview();
        toast.success(
          response?.data?.message || "Review submitted successfully!"
        );
        resetForm();
      } else {
        toast.error(response?.data?.message || "Failed to submit review.");
      }
    } catch (error) {
      toast.error(error || "An error occurred. Please try again.");
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "short", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  useEffect(() => {
    getReview();
  }, []);

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        <div className="review_area pt-4">
          <div className="row">
            <div className="col-lg-8">
              <h4>{review?.length} reviews</h4>
              <div className="comment pt-0 mt_20">
                {review?.map((review, index) => (
                  <div key={index} className="single_comment">
                    <img
                      src={
                        review?.image ? review?.image : "/images/faq_img.jpg"
                      }
                      alt="review"
                      className="img-fluid"
                    />
                    <div className="single_comm_text">
                      <h3>
                        {review?.name}{" "}
                        <span>{formatDate(review?.updated_at)} </span>
                      </h3>
                      <span className="rating">
                        {Array.from({ length: review?.rating })?.map(
                          (_, index) => (
                            <i key={index} className="fas fa-star" />
                          )
                        )}
                        <b>({review?.rating})</b>
                      </span>
                      <p>{review?.review}</p>
                    </div>
                  </div>
                ))}

                {/* <div className="pagination mt_30">
              <div className="row">
                <div className="col-12">
                  <nav aria-label="...">
                    <ul className="pagination">
                      <li className="page-item">
                        <a className="page-link" href="#">
                          <i className="fas fa-long-arrow-alt-left" />
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#">
                          1
                        </a>
                      </li>
                      <li className="page-item active">
                        <a className="page-link" href="#">
                          2
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#">
                          3
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="#">
                          <i className="fas fa-long-arrow-alt-right" />
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div> */}
              </div>
            </div>
            <div className="col-lg-4">
              <div className="post_review">
                <h4>Write a Review</h4>
                <Formik
                  initialValues={{
                    name: "",
                    email: "",
                    review: "",
                    rating: 0,
                  }}
                  validationSchema={validationSchema}
                  onSubmit={handleSubmit}
                >
                  {({ setFieldValue, values }) => (
                    <Form>
                      <p className="rating">
                        <span>Select your rating: </span>
                        {[1, 2, 3, 4, 5].map((star) => (
                          <i
                            key={star}
                            className={`fas fa-star ${
                              values.rating >= star ? "text-warning" : ""
                            }`}
                            onClick={() => setFieldValue("rating", star)}
                            style={{ cursor: "pointer" }}
                          />
                        ))}
                      </p>
                      <ErrorMessage
                        name="rating"
                        component="div"
                        className="text-danger mb-3"
                      />

                      <div className="row">
                        <div className="col-xl-12 mb-3">
                          <Field
                            type="text"
                            name="name"
                            placeholder="Name"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <div className="col-xl-12 mb-3">
                          <Field
                            type="email"
                            name="email"
                            placeholder="Email"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <div className="col-xl-12 mb-3">
                          <Field
                            as="textarea"
                            rows="3"
                            name="review"
                            placeholder="Write your review"
                            className="form-control"
                          />
                          <ErrorMessage
                            name="review"
                            component="div"
                            className="text-danger"
                          />
                        </div>

                        <div className="col-12">
                          <button
                            className="common_btn btn btn-primary"
                            type="submit"
                          >
                            Submit Review
                          </button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
